import { Reducer } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { reduxBatch } from '@manaflair/redux-batch';

import awdViewReducer from '../reducers/awdView.reducer';
import globalReducer from '../reducers/global.reducer';
import telematicsReducer from '../reducers/telematics.reducer';
import { isLocalEnv } from '../utils/constants';

const history = createBrowserHistory();

history.listen(() => {
	// eslint-disable-next-line no-undef
	window.scrollTo(0, 0);
});

const store = configureStore({
	reducer: {
		router: connectRouter(history) as Reducer,
		global: globalReducer,
		awdView: awdViewReducer,
		telematics: telematicsReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({ serializableCheck: false }).concat(
			routerMiddleware(history),
		),
	devTools: isLocalEnv,
	enhancers: [reduxBatch],
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export { store, history };
